import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  OverflowTooltip,
  Space,
} from '@tonic-one/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiTokenRes } from '../types';
import InputFrom from '../InputFrom';

export const AddModal = React.memo(
  (props: {
    visible: boolean;
    onSave: (value: ApiTokenRes) => void;
    onClose: () => void;
    orgId: string;
    category: number;
    title: string;
  }) => {
    const { t } = useTranslation();
    const [isSaveDisable, setSaveDisable] = useState(true);
    const [value, setValue] = useState<ApiTokenRes>({
      category: props.category,
      description: '',
      name: '',
      scope: {
        sweepingMails: false,
        mitigationMails: false,
        mitigationAccounts: false,
        siemSecurityEvents: false,
        remediationMails: false,
        intelligent: false,
      },
    });
    return (
      <Modal
        closeOnEsc
        closeOnOutsideClick={false}
        isClosable
        isOpen={props.visible}
        onClose={props.onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <OverflowTooltip>{props.title}</OverflowTooltip>
          </ModalHeader>
          <ModalBody>
            <InputFrom
              onChange={setValue}
              isSaveDisable={setSaveDisable}
              orgId={props.orgId}
              category={props.category}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              minWidth="20x"
              disabled={isSaveDisable}
              onClick={() => {
                props.onSave(value);
              }}
            >
              {t('administration.apiToken.button.createToken')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={props.onClose}>
              {t('common.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);
